const isLoginFlowInProgress = ref(false);

export function useLoginFlowState() {
  function setLoginFlowInProgress(value: boolean) {
    isLoginFlowInProgress.value = value;
  }

  function getLoginFlowInProgress(): boolean {
    return isLoginFlowInProgress.value;
  }

  return {
    isLoginFlowInProgress: readonly(isLoginFlowInProgress),
    setLoginFlowInProgress,
    getLoginFlowInProgress,
  };
}
